import React from "react";
import ChartCard from "./ChartCard";
import { withTranslation } from "react-i18next";
import { convertToChartData, formatSizeUnits } from "../../helpers/utils";
import { EnvironmentInsight } from "../../models/Environment.model";

interface UnitObjactCpuProps {
  Unit : string;
  MultiplyBy: string;
  DivideBy: string;
}

interface RAMChartCardProps {
  source?: string;
  t?: any;
  environmentInsights?: EnvironmentInsight;
  selectedPod?: string;
  replicas?: number;
}

export const RAMChartCard = (props: RAMChartCardProps) => {
  const { t, environmentInsights, selectedPod, replicas } = props;

  var data_memory_usage = null,
    maxOfRAM = null,
    unitObjectRAM : UnitObjactCpuProps | null = null;

  data_memory_usage = props.source === "overview" ?
    selectedPod &&
    environmentInsights && environmentInsights?.memory_usages?.length > 0 &&
    environmentInsights.memory_usages.filter(
      (itm : any) => itm.metric.namespace === selectedPod
    ) : selectedPod &&
    environmentInsights && environmentInsights?.memory_usages?.length > 0 &&
    environmentInsights.memory_usages.filter(
      (itm : any) => itm.metric?.pod ? itm.metric.pod === selectedPod : itm.metric?.container === selectedPod
    );
  maxOfRAM =
    data_memory_usage && data_memory_usage.length > 0
      ? Math.max(...data_memory_usage[0].values.map((o: any) => o[1]), 0)
      : 0;
  unitObjectRAM = formatSizeUnits(maxOfRAM, 2);

  var maxY =(environmentInsights ? environmentInsights?.total_memory * 1024 * 1024 : 0) / parseInt(unitObjectRAM.DivideBy);
  maxY = props.source === "overview" && replicas ? maxY * replicas : maxY;

  return (
    <ChartCard
      title={t("Environment.OverviewTab.ram")}
      data={
        data_memory_usage && data_memory_usage.length > 0
          ? convertToChartData(data_memory_usage[0].values, 3, unitObjectRAM)
          : []
      }
      lineColor={"blue"}
      suffix={unitObjectRAM && unitObjectRAM.Unit}
      maxY={maxY}
      ytitle={"Memory"}
      xtitle="Time"
      data-test="chart-card"
    />
  );
};

export default withTranslation()(RAMChartCard);
